export default "__VITE_ASSET__DnhML$QM__"